module.exports = "<div class=\"modal\">\r\n  <ng-content></ng-content>\r\n</div>"